import Footer from '../../components/organisms/footer';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';

function MetaNavTastic({ data, context, node }) {
  if (!data) return null;
  const loggedIn = context.session.loggedIn;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const {
    columns,
    links,
    newsletterFormText,
    newsletterFormTextLoggedIn,
    newsletterFormTitle,
    newsletterFormTitleLoggedIn,
    paymentMethods,
    copyright,
    items,
  } = data;

  return (
    <Footer
      isProduct={
        node?.nodeType === 'product' &&
        node?.dataSourceConfigurations?.some(
          (dataSource) =>
            dataSource.dataSourceId === '__master' &&
            dataSource.type === 'apg/product' &&
            dataSource.preloadedValue?.slug !== 'gift-voucher',
        )
      }
      columns={columns}
      loggedIn={loggedIn}
      socialLinks={links}
      mobileLogo={data.mobileLogo}
      desktopLogo={data.desktopLogo}
      newsletterFormText={loggedIn ? newsletterFormTextLoggedIn : newsletterFormText}
      newsletterFormTitle={loggedIn ? newsletterFormTitleLoggedIn : newsletterFormTitle}
      paymentMethods={paymentMethods}
      copyright={copyright}
      items={items}
    />
  );
}

MetaNavTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({
  translate: true,
  connect: {
    node: true,
    context: true,
  },
})(MetaNavTastic);
